export default "__VITE_ASSET__U53MKsQY__"